import brandJson from "./brand.json";

export const brand = brandJson;

export default brand;
